import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Button, Alert, Row, Col } from 'react-bootstrap';
import { loQueSeaAFloat } from '../utils/TypeUtils';

interface PlayerRegistrationFormProps {
  onRegister: (playerData: { name: string; contact: string; latitude: number; longitude: number }) => void;
  selectedLocation: { latitude: number; longitude: number } | null;
}

const PlayerRegistrationForm: React.FC<PlayerRegistrationFormProps> = ({ onRegister, selectedLocation }) => {
  const { t } = useTranslation();
  const [name, setName] = useState<string>('');
  const [contact, setContact] = useState<string>('');
  const [location, setLocation] = useState<{ latitude: number; longitude: number } | null>(selectedLocation);
  const [mapCenter, setMapCenter] = useState<[number, number]>([-34.6037, -58.3816]); // Default to Buenos Aires
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLocation(selectedLocation);
    if (selectedLocation) {
      setMapCenter([selectedLocation.latitude, selectedLocation.longitude]);
    }
  }, [selectedLocation]);

  useEffect(() => {
    if (location) {
      setMapCenter([location.latitude, location.longitude]);
    }
  }, [location]);

  
const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!location) {
      setError(t('locationRequired'));
      return;
    }
    if (name && contact && location) {
      onRegister({ name, contact, latitude: location.latitude, longitude: location.longitude });
      setName('');
      setContact('');
      setLocation(null);
      setError(null);
    } else {
      setError(t('allFieldsRequired'));
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      {error && <Alert variant="danger">{error}</Alert>}

      <Form.Group className="mb-3" controlId="formName">
        <Form.Label>{t('name')}</Form.Label>
        <Form.Control
          type="text"
          placeholder={t('enterName')}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId="formContact">
        <Form.Label>{t('contact')}</Form.Label>
        <Form.Control
          type="text"
          placeholder={t('enterContact')}
          value={contact}
          onChange={(e) => setContact(e.target.value)}
        />
      </Form.Group>

      <Row className="mb-3 align-items-center">
        <Col xs={12} md={6}>
          <Form.Group>
            {location && (
              <Form.Text className="ms-2 text-success">
                {t('locationSelected', { lat: loQueSeaAFloat(location.latitude).toFixed(2), lon: loQueSeaAFloat(location.longitude).toFixed(2) })}
              </Form.Text>
            )}
          </Form.Group>
        </Col>
        <Col xs={12} md={6} className="d-grid gap-2">
          <Button variant="primary" type="submit">
            {t('register')}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default PlayerRegistrationForm;